<template>
	<div class="SelectedFiltersContainer" :class="{ Visible: filtersApplied || isBusy }">
		<div class="SelectedFiltersHeader" v-if="displayHeader && (filtersApplied || isBusy)">
			<div><span v-if="displayTitle">Selected filters</span></div>
			<button type="button" class="ClearButton" ref="clearAllButtonRef" @click="clearAll" v-if="displayClearAll && removableFiltersCount > 0 && !isBusy">
				{{ removableFiltersCount === 1 ? 'Clear filter' : `Clear ${removableFiltersCount} filters` }}
				<i class="lnr-redo2 ButtonIcon"></i>
			</button>
			<Tracking v-if="clearAllButtonTrackingData" :data="clearAllButtonTrackingData"></Tracking>
		</div>

		<SelectedFiltersSkeletonLoader v-if="isBusy" />
		<div v-else :class="[collapseToDefaultNumberOfRows ? 'Collapsed' : '']" class="FilterTagContainer" ref="filterTagContainerRef">
			<div v-for="(tag, index) in tags" :key="tag.id">
				<Tag :tag="tag" :icon="'lnr-cross'" :trackClick="true" :trackingPayload="tagTrackingPayload[index]"/>
			</div>
		</div>
		<div>
			<button type="button" class="ShowMoreButton" ref="showMoreButtonRef" @click="showMore" v-if="collapseToDefaultNumberOfRows && shouldDisplayShowMore">
				Show more
				<i class="lnr-plus ButtonIcon"></i>
			</button>
			<button type="button" class="ShowLessButton" ref="showLessButtonRef" @click="showLess" v-if="collapseToDefaultNumberOfRows && shouldDisplayShowLess">
				Show less
				<i class="lnr-minus ButtonIcon"></i>
			</button>
		</div>
	</div>
</template>

<script lang="ts" src="./SelectedFilters.ts"></script>
<style lang="scss" src="./SelectedFilters.scss" scoped></style>
